/**
 * GoHighLevel opt-in webhooks.
 *
 * All triggers live on GHL location `tgMLVMRnjZzOsRZ1wFVh`. Recovered from the
 * Manus source during the Hostinger port; the mapping below is what the code
 * actually did, not what the GHL workflow names suggest.
 *
 *   442f43a1-…  → /claude-quick-wins            (ClaudeQuickWinsPage)
 *   f86514be-…  → /littlebird-quickwins   AND   /gemini-notebook-quickwins
 *   a3406fb3-…  → account signup (server-side, see server/routers.ts)
 *
 * ⚠ f86514be is shared by two different lead magnets. Both opt-ins land in the
 * same automation, distinguishable only by the `source` field in the payload.
 * If Caren's welcome sequences differ per magnet, this is a bug that predates
 * the port and needs a second trigger created on the GHL side. Behaviour is
 * preserved here exactly as it was; do not "fix" it without confirming GHL.
 *
 * Property 1 uses a fourth trigger (64f693da-…) that this app never calls.
 */

const LOCATION_ID = "tgMLVMRnjZzOsRZ1wFVh";
const BASE = `https://services.leadconnectorhq.com/hooks/${LOCATION_ID}/webhook-trigger`;

export const GHL_WEBHOOKS = {
  claudeQuickWins: `${BASE}/442f43a1-e64c-4898-b9de-5149b7cf0bab`,
  littlebirdQuickWins: `${BASE}/f86514be-1e06-4eb8-b2c9-4906474de213`,
  notebookLmQuickWins: `${BASE}/f86514be-1e06-4eb8-b2c9-4906474de213`,
} as const;

/**
 * True only where leads should reach the live CRM.
 *
 * Local development and the staging deploy must not write into Caren's
 * GoHighLevel account, so the POST is skipped and logged unless
 * VITE_GHL_WEBHOOKS_ENABLED is exactly "true".
 */
const enabled = import.meta.env.VITE_GHL_WEBHOOKS_ENABLED === "true";

export type OptInPayload = {
  firstName: string;
  email: string;
  source: string;
};

export async function submitOptIn(
  webhook: string,
  payload: OptInPayload
): Promise<void> {
  if (!enabled) {
    console.info(
      "[GHL] webhook skipped (VITE_GHL_WEBHOOKS_ENABLED is not \"true\")",
      { webhook, payload }
    );
    return;
  }

  await fetch(webhook, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
